import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-admin-console',
  templateUrl: './admin-console.component.html',
  styleUrls: ['./admin-console.component.css']
})
export class AdminConsoleComponent implements OnInit {
	respObject: any;
	compObj: any;
	compData: any;
  fileData=[];

  dataType = "";
  fileYear="";
  fullYear: number = new Date().getFullYear();
  yearArr= [];
  yearfArr= [];
  filefYear="";
  selectMonth="";
  fileQuarter="";
  companyId="";

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;
  downLoadPath = this._rest.FILE_PATH;
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
    this.dataType = "";
    this.selectMonth="";
    this.fileQuarter="";
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearArr.push(i);
      //this.fileYear= i+"";
    }
    for (var i= this.fullYear-10;i<=this.fullYear;i++){
      this.yearfArr.push(i+"-"+(i+1));
      //this.filefYear = i+"-"+(i+1);
    }
    const cRData = {}
    this._rest.companyList(cRData).subscribe((res) => {
      this.compObj = res;
      this.compData = this.compObj.details;      
    });

    this.searchFile(1)
  }
  goToConsoleView(authority, fdata){
    console.log(authority,fdata['templateType1'],fdata['monthly'],fdata['year']  )
    console.log(fdata)
    if (fdata['monthly'] == ''){
      var period = fdata['quarterly']
    }else{
      var period = fdata['monthly']
    }
    fdata['templateType1'] = fdata['templateType1'].replace( ' ', '_')
    if (authority=="admin") {
      
      this.router.navigate(['/admin/consoleview/' + fdata['templateType1'] +'/'+ '0' +'/'+fdata['templateType1']+'_'+ period +'_'+fdata['year']+'.xlsx']);
    }

  }
  searchFile(curPage){
    this.curPage=curPage;
    var fd = {};
    if(this.dataType!=""){
    	fd["templateType"]=this.dataType;
    }
    if(this.dataType == "Segment"){
      fd["year"]=this.fileYear;
      fd["monthly"]=this.selectMonth;
    } else if(this.dataType == "Form" || this.dataType == "Financial Highlights" || this.dataType == "Data on Motor" || this.dataType == "Reinsurance" ){     
      fd["year"]=this.filefYear;
      fd["quarterly"]=this.fileQuarter;
    } else if(this.dataType == "Gross & Net Statistics" || this.dataType == "Large Loss"){     
      fd["year"]=this.filefYear;
    }
    if(this.companyId!=""){
    	fd["companyId"]=this.companyId;
    }
    console.log(fd);
    this.fileData = [];
    this._rest.consoleListAdmin(fd).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.error== 0){
        for (var i =0;i<this.respObject.resp.data.length;i++){
          var tempData=this.respObject.resp.data[i];
          tempData["templateType1"] = tempData["templateType"].split(" ").join("_");
          this.fileData.push(tempData);
        }
        this.totalRows = this.respObject.resp.info;
        this.noOfRows=this.respObject.resp.data.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.fileData=[];
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
    });
  }
}

